var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.category)?_c('span',{staticClass:"category"},[_vm._v(" "+_vm._s(_vm.category)+" ")]):_vm._e(),_c('span',{staticClass:"number"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }